// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterList_wrapper__uJU77"};